import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import EditorIFrame from "./EditorIFrame";

ReactDOM.render(
  <React.StrictMode>
    <EditorIFrame />
  </React.StrictMode>,
  document.getElementById("root")
);
